import {Component} from "react";
import {IActionBase} from "./IActionBase";
import {ActionsManager} from "./actionsManager";
import {store} from "../../redux/storeConfig/store";
import {callPostService} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";
import {utils_ui} from "../utils/utils_ui";
import {dataUtils} from "../js/dataUtils";
import {eSystemEvents, fireApplyooEvent} from "../infrastructure/useApplyooTriggers";
import {executeApplyooComponentsFunction, getApplyooResourceByCode} from "../infrastructure/useApplyooComponent";

export class action_AP_ValidateForm extends Component implements IActionBase {
    actionCode = "action_AP_ValidateForm";
    actionName = "Validate Form";

    Execute = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any) => {

        var queryName = "";

        if (!!prmActionParameters
            && !!prmActionParameters.QueryName) {
            queryName = prmActionParameters.QueryName;
        }

        let lstValidationErrors:any = utils_ui.validate(queryName);

        if (!!prmActionParameters?.ValidationParams) {
            let validationInfoObj:any = {"command": "ValidateReource", "projectID": 2212, "resourceCode": "ValidateSplitKeyFunds", "elementClientID": "UI_KendoGrid_Funds"}
            //dataUtils.parseData(prmActionParameters?.ValidationParams)

            let validationObj:any = getApplyooResourceByCode(validationInfoObj)

            if (!!validationObj) {
                let lstExtValidationErrors:any = validationObj(validationInfoObj);

                if (lstExtValidationErrors.length > 0) {
                    for (const currExtValidationError of lstExtValidationErrors) {
                        lstValidationErrors.push(currExtValidationError)
                    }
                }
            }
        }

        if (lstValidationErrors.length > 0){
            let isValid:any = false;

            //fireApplyooEvent({eventType: eSystemEvents.OnBeforeSave_CheckDataValidation, metadata: currDataRequestObj})
            //SET_VALIDATION_ERRORS
            store.dispatch({type: 'SET_VALIDATION_ERRORS',  lstValidationErrors: lstValidationErrors, queryName: queryName })

            //executeApplyooComponentsFunction("onValidationError",{lstValidationErrors: lstValidationErrors, queryName: queryName})
            //prmActionsManager?.triggersManager.raiseEvent(prmActionsManager,eSystemEvents.OnDataValidationFail,currDataRequestObj)
        }
        else {
            if (!!prmActionParameters?.LstActionsAfterActionSucceed
                && prmActionParameters?.LstActionsAfterActionSucceed.length > 0) {
                prmActionsManager.executeActions(prmActionParameters?.LstActionsAfterActionSucceed, prmElementObj)
                // APPLYOO.runtimeUtils.scopeObj.executeArrActions(arrSelectedTrigger[0].actions, prmElement);
            }

            //fireApplyooEvent({eventType: eSystemEvents.OnDataValidationSucceed, metadata: currDataRequestObj})

            //prmActionsManager?.triggersManager.raiseEvent(prmActionsManager,eSystemEvents.OnDataValidationSucceed,currDataRequestObj)
        }

        //
        //
        // // let pageTriggers = JSON.parse(APPLYOO.runtimeUtils.rootScopeObj.selectedPageMetadataObj.PageProperties.TriggersObj);
        // const pageStructure: any = store.getState().store_PageStructure.pageStructure
        // const pageTriggers = JSON.parse(pageStructure?.PageProperties?.TriggersObj)
        //
        // let arrSelectedTrigger = pageTriggers?.filter((prmItem:any) => {
        //     return prmItem.name == prmActionParameters.SelectedTrigger;
        // })
        // if (arrSelectedTrigger.length > 0 && !!arrSelectedTrigger[0].actions) {
        //     prmActionsManager.executeActions(arrSelectedTrigger[0].actions, prmElementObj)
        //     // APPLYOO.runtimeUtils.scopeObj.executeArrActions(arrSelectedTrigger[0].actions, prmElement);
        // }
    }
}